
import type { PropType } from 'vue'
import { Fade } from '@empathyco/x-components'
import { SearchInput } from '@empathyco/x-components/search-box'
import { defineComponent } from 'vue'

import SearchBox from '../shared/search-box.component.vue'
import XHistoryQueries from './x-history-queries.component.vue'

export default defineComponent({
  name: 'XSearchbox',
  components: {
    SearchBox,
    SearchInput,
    Fade,
    XHistoryQueries,
  },
  props: {
    placeholder: {
      type: String,
    },
    size: {
      type: String as PropType<'medium' | 'large'>,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
    },
    inputQuery: {
      type: String,
      default: '',
    },
    infoPillLabel: {
      type: String,
    },
    infoPillBackgroundColor: {
      type: String,
      default: () => 'neutral',
    },
  },
  data() {
    return {
      baseClass: 'epb-x-searchbox',
      toggleHistoryQueries: false,
    }
  },
  computed: {
    query(): string {
      return this.$x.query.searchBox
    },
  },
  watch: {
    '$x.query.search': function (): void {
      this.toggleHistoryQueries = !this.query
    },
  },
  mounted(): void {
    const initialValue =
      this.inputQuery && this.inputQuery !== this.query ? this.inputQuery : this.query

    this.$refs.searchInput.$el.value = initialValue
    window.addEventListener('click', this.onToggleHistoryQueries)
  },
  beforeDestroy(): void {
    window.removeEventListener('click', this.onToggleHistoryQueries)
  },
  methods: {
    onClearQuery(): void {
      this.$x.emit('UserPressedClearSearchBoxButton')
    },
    onToggleHistoryQueries({ target }: MouseEvent): void {
      this.toggleHistoryQueries =
        !this.disabled && document.getElementById('searchbox').contains(target as Node)
    },
  },
})
